import { useNavigate } from 'react-router'

import { ScreenBackground, TopBar } from '@/shared/ui'

/**
 * Stands in for a screen that is routed but not built yet. It names the Figma
 * node and the backend section that serve it, so the skeleton stays a useful
 * map rather than a wall of "TODO".
 */
export interface PlaceholderProps {
  title: string
  /** Figma node id, e.g. `202:110`. */
  node?: string
  /** Section of docs/backend-routes.md that serves this screen. */
  backend?: string
  note?: string
}

const FIGMA_FILE = 'ZxszQVAOGcLg9Tn0dMsbyE'

export function PlaceholderScreen({ title, node, backend, note }: PlaceholderProps) {
  const navigate = useNavigate()
  return (
    <ScreenBackground variant="app" className="flex flex-col">
      <TopBar title={title} onBack={() => void navigate(-1)} />
      <div className="sx-col-app flex flex-1 flex-col gap-3 pt-6">
        <div className="rounded-16 border border-line-8 bg-surface-5 p-4">
          <p className="text-14 text-ink-80">این صفحه هنوز ساخته نشده است.</p>
          <dl className="mt-3 flex flex-col gap-2 text-13">
            {node ? (
              <div className="flex items-center justify-between gap-3">
                <dt className="text-ink-50">نود فیگما</dt>
                <dd>
                  <a
                    className="sx-ltr text-primary-soft underline"
                    href={`https://www.figma.com/design/${FIGMA_FILE}/SaminX?node-id=${node.replace(':', '-')}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {node}
                  </a>
                </dd>
              </div>
            ) : null}
            {backend ? (
              <div className="flex items-center justify-between gap-3">
                <dt className="text-ink-50">قرارداد بک‌اند</dt>
                <dd className="sx-ltr text-ink-88">backend-routes.md {backend}</dd>
              </div>
            ) : null}
          </dl>
          {note ? <p className="mt-3 text-13 text-ink-62">{note}</p> : null}
        </div>
      </div>
    </ScreenBackground>
  )
}
